import { render, staticRenderFns } from "./CmsIndexDetails.vue?vue&type=template&id=47a18a0d&scoped=true"
import script from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
export * from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
import style0 from "./CmsIndexDetails.vue?vue&type=style&index=0&id=47a18a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a18a0d",
  null
  
)

export default component.exports